import { Component, OnInit } from '@angular/core';
import { Appli } from '../../../models/appli';
import { AdminAppliService } from '../appli.service';
import { Route, Router } from '@angular/router';
import { ColDef, ColGroupDef } from 'ag-grid-community';

@Component({
  selector: 'ozm-appli-list',
  templateUrl: './appli-list.component.html',
  styleUrls: ['./appli-list.component.scss']
})
export class AdminAppliListComponent implements OnInit{
  applis: Array<Appli> = [];
  selected: boolean = false;
  selectedRow: Appli;
  private _gridApi;
  private _gridColumnApi;
  columnDefs : (ColDef<Appli, any> | ColGroupDef<Appli>)[]= [
    {headerName: 'Id', field: '_id'},
    {headerName: 'default', field: 'default'},
    { headerName: 'Name', field: 'name' },
    { headerName: 'Icon', field: 'icon' },
    { headerName: 'Category', field: 'category' },
    { headerName: 'Sub Category', field: 'subCategory' },
    { headerName: 'Link', field: 'link' },
    { headerName: 'FallbackUrl', field: 'fallbackUrl' },
    { headerName: 'FallbackUrl2', field: 'fallbackUrl2' },
    { headerName: 'Active', field: 'active' },
    { headerName: 'androidImageUrl', field: 'androidImageUrl'}
  ];

  constructor(
    private _adminAppliService: AdminAppliService,
    private _router:Router
  ) {}

  ngOnInit(): void {
    console.log('$$$$$$$$$$$$$$$$$$$$$$$$$$$$');
     this._adminAppliService.getApplis1({}).subscribe((applis: Appli[]) => {
      
      console.log(applis);
      this.applis = applis
    })
      
  }

  onGridReady(params) {
    this._gridApi = params.api;
    this._gridColumnApi = params.columnApi;

  }

  onSelectionChanged($event) {

  }
  // rowCount() {
  //   if(this._gridApi) {
  //     return this._gridApi.gridOptionsWrapper.gridOptions.rowData.length
  //   }
  //   return 0;
  // }

  viewDetail() {
    

  }

}
